import { render, staticRenderFns } from "./EventRowItem.vue?vue&type=template&id=677d7244&scoped=true"
import script from "./EventRowItem.vue?vue&type=script&lang=ts"
export * from "./EventRowItem.vue?vue&type=script&lang=ts"
import style0 from "./EventRowItem.vue?vue&type=style&index=0&id=677d7244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677d7244",
  null
  
)

export default component.exports